import { rei } from "@/services/api"

class ListagemRegistrosService {
  static saveCampos (data) {
    return rei.post(`salvar-filtro-registros-listagem`, data)
      .then(res => res.data)
  }

  static getConfig (data) {
    return rei.get(`get-by-chave`, { params: data })
      .then(res => res.data)
  }

  static getPdf (data) {
    const options = {
      responseType: 'arraybuffer'
    }

    return rei.post(`relatorios-registros-listagem`, data, options)
      .then(response => {
        let blob = new Blob([response.data], { type: 'application/pdf' })
        let url = window.URL.createObjectURL(blob)

        return url
      })
  }
}

export default ListagemRegistrosService
